/** Returns whether the pathname should use the PR v2 experience. */
export function isPrV2Route(pathname: string): boolean {
  return pathname.startsWith('/pr/');
}

const PR_V2_ROUTE_PATTERN = /^\/pr\/([^/]+)\/([^/]+)\/pull\/([^/]+)(?:\/|$)/;

export type PrV2RouteContext = {
  owner: string;
  repo: string;
  number: string;
};

/**
 * Parses `/pr/:owner/:repo/pull/:number` from the canonical PR route.
 */
export function parsePrV2Route(pathname: string | null): PrV2RouteContext | null {
  if (!pathname) {
    return null;
  }

  const match = pathname.match(PR_V2_ROUTE_PATTERN);
  if (!match) {
    return null;
  }

  const ownerCapture = match[1];
  const repoCapture = match[2];
  const numberCapture = match[3];
  if (!ownerCapture || !repoCapture || !numberCapture) {
    return null;
  }

  try {
    return {
      owner: decodeURIComponent(ownerCapture),
      repo: decodeURIComponent(repoCapture),
      number: decodeURIComponent(numberCapture),
    };
  } catch {
    return null;
  }
}
